import {
  PROMO_TILE,
  SHOP_THE_ROOM,
} from "@/components/ShopTheRoomDetails/Analytics/constant"

export const getProductInfo = (data = {}, skuPrepend = "") => {
  const {
    ProductLocalCategory_s: productCategory = "",
    imageUrl = "",
    ProductDescriptionProductShort_s: decs = "",
    listPrice = 0,
    price = 0,
    ProductBrandName_s: productBrandName = "",
    sku_s: sku = "",
    productDiscontinued_b: discontinued = false,
    availableQuantity = 0,
    ["Color.SKU.Details_ss"]: colordataString = "",
    itemQuantity: quantity = 1,
  } = data

  const getColorBySku = (colordataString, sku) => {
    for (const entry of colordataString) {
      const parts = entry.split("|")
      if (parts.length > 2) {
        const color = parts[0]
        const entrySku = parts[2]
        if (entrySku === sku) {
          return color
        }
      }
    }
    return null
  }

  const color = getColorBySku(colordataString, sku)

  const productinfo = {
    bundleIds: "n/a",
    bundleProductColors: "n/a",
    category: productCategory?.toLowerCase(),
    defaultImageName: imageUrl,
    description: decs?.toLowerCase(),
    frequency: "n/a",
    globalDiscount:
      listPrice === price ? "n/a" : Number((listPrice - price).toFixed(2)),
    globalOffer: "n/a",
    globalPromotionPrice: Number(price),
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    itemType: "product",
    numberOfReviews: "n/a",
    pdpType: "regular finished Goods",
    priceState: "regular price",
    productBasePrice: Number(listPrice),
    productBrand: "kohler",
    productCategory: productCategory?.toLowerCase(),
    productCollectionsName: productBrandName?.toLowerCase(),
    productColor: color?.toLowerCase() || "deafult",
    productCouponCode: "n/a",
    productCoupondiscount: 0,
    productFindingMethod: "n/a",
    productID: `${skuPrepend}${sku}`,
    productName: productBrandName?.toLowerCase(),
    productPartnerBuyNow: "n/a",
    productRoom: "n/a",
    productSalePrice: Number(price),
    productSaleable: !discontinued,
    productSkuOption: false,
    productStatus: availableQuantity > 0 ? "in stock" : "out of stock",
    productSuperSku: false,
    productTileName: productBrandName?.toLowerCase(),
    quantity: Number(quantity),
    ratings: "n/a",
    waterSenseProduct: false,
  }
  return productinfo
}

export const datlayerForProductclick = (
  url = "",
  sku = "",
  data = {},
  title = "",
  skuPrepend = ""
) => {
  const titletext = title ? title.toLowerCase() : "product navigation"
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${SHOP_THE_ROOM}:${titletext}`,
    eventMsg: "n/a",
    eventName: `${SHOP_THE_ROOM}:${titletext}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: title
      ? title?.toLowerCase()
      : data.ProductBrandName_s?.toLowerCase(),
    internalLinkPosition: SHOP_THE_ROOM,
    internalLinkType: `plp:${
      titletext ? titletext?.toLowerCase() : "product navigation"
    }`,
    internalLinkURL: url
      ? (url.indexOf("http") === -1 ? window.location.origin : "") + url
      : "n/a",
    internalLinkZoneName: `${SHOP_THE_ROOM}:${PROMO_TILE}`,
  }
  const productInfo = getProductInfo(data, skuPrepend)
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const datlayerForProductAddToCart = (
  data = {},
  title = "",
  skuPrepend = ""
) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${SHOP_THE_ROOM}:${title}`,
    eventMsg: "n/a",
    eventName: `${SHOP_THE_ROOM}:${title}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: `${title}`,
    internalLinkPosition: `${SHOP_THE_ROOM}`,
    internalLinkType: `plp:${title}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `${SHOP_THE_ROOM}:${PROMO_TILE}`,
  }
  const productInfo = getProductInfo(data, skuPrepend)
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const datlayerForProductAddToWishlist = (
  data = {},
  title = "",
  skuPrepend = "",
  deleteCheck = false
) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${SHOP_THE_ROOM}:${title}`,
    eventMsg: "n/a",
    eventName: `${SHOP_THE_ROOM}:${title}`,
    eventStatus: "n/a",
    eventType: `wishlist ${deleteCheck ? "delete" : "save"}`,
    internalLinkName: `${title}`,
    internalLinkPosition: `${SHOP_THE_ROOM}`,
    internalLinkType: `plp:${title}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `${SHOP_THE_ROOM}:${PROMO_TILE}`,
  }
  const productInfo = getProductInfo(data, skuPrepend)
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const datlayerForBreadCrump = (title = "", url = "") => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${SHOP_THE_ROOM}:breadcrumb`,
    eventMsg: "n/a",
    eventName: `${SHOP_THE_ROOM}:breadcrumb`,
    eventStatus: "n/a",
    eventType: `navigation`,
    internalLinkName: title.toLowerCase(),
    internalLinkPosition: `${SHOP_THE_ROOM}`,
    internalLinkType: `plp:breadcrumb`,
    internalLinkURL: url
      ? (url.indexOf("http") === -1 ? window.location.origin : "") + url
      : "n/a",
    internalLinkZoneName: `${SHOP_THE_ROOM}:${PROMO_TILE}`,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}, productInfo = null) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const event = "cmp:click"
  if (productInfo) {
    window.adobeDataLayer.push({
      event,
      eventInfo,
      page,
      productInfo,
    })
  } else {
    window.adobeDataLayer.push({
      event,
      eventInfo,
      page,
    })
  }
}
